import { Modal } from 'antd'
import React from 'react'
import RichText from 'components/ui/dataEntry/other/RichText'

const CustomMetaRichTextModal = ({
  title,
  visible,
  onCancel,
  onOk,
  onChange,
  value,
  id,
  afterClose
}) => {
  return (
    <Modal
      className='general-modal rich-text-custom-meta-field-modal'
      title={title}
      maskClosable={false}
      visible={visible}
      closable={false}
      centered
      destroyOnClose
      width={'calc(100vw - 150px)'}
      // footer={[
      //   <Button key='back' onClick={handleCancel}>
      //     Close
      //   </Button>]}
      getContainer={() => document.getElementById('general-details')}
      onCancel={onCancel}
      onOk={onOk}
      bodyStyle={{ height: '80vh' }}
      afterClose={afterClose}
    >
      <div className='rich-text-wrapper'>
        <RichText
          id={id}
          text={value}
          onRichTextChange={onChange}
          showCloseIcon={false}
        />
      </div>
    </Modal>
  )
}

export default CustomMetaRichTextModal
